import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import MultipleLinePlotAnimation from '../../../graphics/MultipleLinePlotAnimation';
import { Title, Container } from './styles';
import { Data } from './types';

const MultipleLinePlotAnimationPage: React.FC = () => {
  const [data, setData] = React.useState<Data[]>([]);
  const dataState = useSelector((state: ApplicationState) => state.DashSla.data['departamentos']);

  React.useEffect(() => {
    dataState?.length > 0 ? setData(dataState) : setData([]);
  }, [dataState]);
  return (
    <Container>
      <Title>Pendentes por departamento</Title>
      <div>
        <MultipleLinePlotAnimation data={data} />
      </div>
    </Container>
  );
};

export default MultipleLinePlotAnimationPage;
